import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
export function PainSection() {
  return <section className="bg-cosmic-dark relative z-10 py-12 px-6" data-id="element-162">
      <ScrollReveal className="max-w-[680px] mx-auto flex flex-col items-center text-center" data-id="element-163">
        <p className="text-gold uppercase tracking-widest text-sm font-semibold mb-10" data-id="element-164">
          Does This Sound Familiar?
        </p>

        <div className="text-lunar-white text-lg md:text-xl leading-[1.8] font-lato space-y-6 text-left w-full" data-id="element-165">
          <p data-id="element-166">It's 11:47 PM.</p>

          <p data-id="element-167">You're lying in bed, staring at the ceiling.</p>

          <p data-id="element-168">
            Your phone is right there. You've checked it four times in the last
            ten minutes.
          </p>

          <p data-id="element-169">Nothing.</p>

          <p data-id="element-170">No text. No call. No sign from him.</p>

          <p data-id="element-171">And the worst part? You don't even know what you did wrong.</p>

          <p data-id="element-172">
            You've tried everything. You've played it cool. You've been 'busy.'
            You've manifested for months with vision boards, journaling, and
            affirmations...
          </p>

          <p data-id="element-173">
            ...and yet here you are. Alone. Wondering if love like that is even
            real for you.
          </p>

          <p data-id="element-174">It is. And it's not your fault it hasn't arrived yet.</p>

          <p data-id="element-175">The problem isn't your energy.</p>

          <p className="text-xl md:text-2xl font-semibold" data-id="element-176">
            The problem is <span className="text-gold" data-id="element-177">WHEN</span> you're trying
            to shift it.
          </p>
        </div>

        <div className="mt-12 bg-cosmic-card border-l-4 border-gold p-6 md:p-8 rounded-r-lg shadow-lg w-full text-left" data-id="element-178">
          <p className="text-gold font-fell italic text-xl md:text-2xl leading-relaxed" data-id="element-179">
            "Most women try to manifest love during the day — when their
            conscious mind is loudest. That's exactly why it doesn't work."
          </p>
        </div>
      </ScrollReveal>
    </section>;
}